import { render, staticRenderFns } from "./Customer-cases.vue?vue&type=template&id=1c13a74b&scoped=true"
import script from "./Customer-cases.vue?vue&type=script&lang=js"
export * from "./Customer-cases.vue?vue&type=script&lang=js"
import style0 from "./Customer-cases.vue?vue&type=style&index=0&id=1c13a74b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c13a74b",
  null
  
)

export default component.exports